import { useCallback, useState } from 'react';
import useAuth from './useAuth';
import { useWebSocketContext } from '../context/Context';

const useWebSocketManagerForOAuth = () => {
    const auth = useAuth();
    const { user } = auth;
    const [oAuthWindow, setOAuthWindow] = useState(null);
    const wsManager = useWebSocketContext();

    const initConnection = useCallback(() => {
        if (!user || !user.user_id) {
            throw new Error('User is not logged in');
        }

        if (!wsManager || !wsManager.ws) {
            throw new Error('WebSocket is not ready');
        }
        if (wsManager.ws.readyState === WebSocket.OPEN) {
            wsManager.connectUser(user.user_id);
        }
    }, []);

    return {
        initConnection,
        oAuthWindow,
        setOAuthWindow,
    };
};

export default useWebSocketManagerForOAuth;
